import { memo } from 'react';

import { IconOpenPreview } from '@components/icons/open-preview';
import { Menu } from '@components/menu';
import { useScopedTranslate } from '@locale/translate';

import { ACTION_TYPES, getActionLabel } from 'ui/actions/action-config';
import { NodeActions } from 'ui/journey-builder/node-types/common';
import { JourneyNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

import { previewEmailLocale } from './email-preview';
import { buildEmailPreviewProps, usePreviewEmailModal } from './email-preview-modal';

const ACTION_TYPE = ACTION_TYPES.send_email;

export const Node = memo((node: JourneyNode<typeof ACTION_TYPE>) => {
  const { t } = useScopedTranslate(locale);
  const showPreviewModal = usePreviewEmailModal();

  return (
    <NodeContainer node={node}>
      <JourneyNodeActionCard node={node} label={getActionLabel(ACTION_TYPE)}>
        <NodeActions
          node={node}
          customMenuItems={
            <Menu.Item
              label={t('previewEmail')}
              icon={<IconOpenPreview />}
              onSelect={() =>
                showPreviewModal(
                  buildEmailPreviewProps(node.data?.values, node.id, t('noRecipient')),
                )
              }
            />
          }
        />
      </JourneyNodeActionCard>
    </NodeContainer>
  );
});

const locale = {
  en: {
    ...previewEmailLocale.en,
    noRecipient: 'Email has no recipients',
  },
};
